module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"ngFormly","amd":"angular-formly","commonjs2":"angular-formly","commonjs":"angular-formly"}
 ** module id = 22
 ** module chunks = 0
 **/